import {
  getRevenueTypesData,
  searchRevenueTypesData,
} from "@/Api/revenueTypes";
import { AddExpenseTypeBtn } from "@/App/RevenueTypes/Add";
import { TableData } from "@/App/RevenueTypes/Table";
import { SearchComponent } from "@/App/Tenants/Search";
import { If } from "@/components/If";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { usePermissions } from "@/hooks/usePermissions";
import { TypePageActions } from "@/pages/Plans";
import { ApiDataProps } from "@/pages/Tenants";
import { ExpenseTypeProps } from "@/types/expenseType";
import { useEffect, useState } from "react";

export const PageList = () => {
  const [typesData, setTypesData] = useState(
    {} as ApiDataProps<ExpenseTypeProps>
  );
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();

  useEffect(() => {
    (async () => {
      const { data } = await getRevenueTypesData();
      setTypesData(data?.response);
      setState("production");
    })();
  }, []);

  const pageActions: TypePageActions = {
    next: async () => {
      if (typesData?.current_page < typesData?.last_page) {
        setState("loading");

        const { data } = await getRevenueTypesData(typesData?.current_page + 1);
        setTypesData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (typesData?.current_page > 1) {
        setState("loading");

        const { data } = await getRevenueTypesData(typesData?.current_page - 1);
        setTypesData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (typesData?.current_page !== typesData?.last_page) {
        setState("loading");

        const { data } = await getRevenueTypesData(typesData?.last_page);
        setTypesData(data?.response);
        setState("production");
      }
      return;
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-income-types-list")}>
        <div className="flex justify-center md:justify-between items-center flex-wrap gap-2">
          <h2 className="text-2xl font-semibold flex gap-2 items-center">
            Tipos de Receitas
          </h2>
          <If condition={hasPermission("create-income-type")}>
            <AddExpenseTypeBtn updateFront={setTypesData} />
          </If>
        </div>
        <div className="flex flex-col gap-3">
          <SearchComponent
            updateFront={setTypesData}
            setState={setState}
            funcSearch={searchRevenueTypesData}
            placeholder="Pesquisar tipos de receitas"
          />
          {state === "loading" ? (
            <CreateLoaderTable cols={8} lines={6} />
          ) : (
            <TableData
              updateFront={setTypesData}
              dataApi={typesData}
              pageActions={pageActions}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
